// extracted by mini-css-extract-plugin
export default {"delWrap":"index__delWrap__2Omx8","title":"index__title__3ust2","tip":"index__tip__QfUvy","btnWrap":"index__btnWrap__26TWd","btn":"index__btn__3clmN"};